import { useSelector } from "react-redux";
import { useMediaQuery } from "react-responsive";
import { currentOrganizationSelector, userSelector } from "../store/selectors";

function useOrganizationRole() {
  const currentOrganization = useSelector(currentOrganizationSelector);
  const user = useSelector(userSelector);

  // console.log("is from limits: ", currentOrganization, organizationsTariffes);

  if (!user || !currentOrganization) return null;
  const role = user.organizationRoles.find(
    (org) => org.organizationId === currentOrganization.id
  );
  return role;
}

export default useOrganizationRole;
